import { ConstellationScreenSize, ScreenType } from '@zg-rentals/rental-manager-env-base';

const minWidths = {
  xs: 500,
  sm: 600,
  md: 700,
  lg: 800,
  xl: 1024,
  xxl: 1281,
};

const width = (): number => {
  if (typeof window !== 'undefined') {
    return window.innerWidth && document.documentElement.clientWidth
      ? Math.min(window.innerWidth, document.documentElement.clientWidth)
      : window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }
  return 0;
};

const size = (currentWidth: number = width()) => {
  if (currentWidth < minWidths.sm) {
    return ConstellationScreenSize.XS;
  }
  if (currentWidth < minWidths.md) {
    return ConstellationScreenSize.SM;
  }
  if (currentWidth < minWidths.lg) {
    return ConstellationScreenSize.MD;
  }
  if (currentWidth < minWidths.xl) {
    return ConstellationScreenSize.LG;
  }
  if (currentWidth < minWidths.xxl) {
    return ConstellationScreenSize.XL;
  }
  if (currentWidth >= minWidths.xxl) {
    return ConstellationScreenSize.XXL;
  }
  return ConstellationScreenSize.XXL;
};

const type = (currentSize = size()) => {
  switch (currentSize) {
    case ConstellationScreenSize.XS:
    case ConstellationScreenSize.SM:
      return ScreenType.MOBILE;
    case ConstellationScreenSize.MD:
    case ConstellationScreenSize.LG:
      return ScreenType.TABLET;
    case ConstellationScreenSize.XL:
    case ConstellationScreenSize.XXL:
    default:
      return ScreenType.DESKTOP;
  }
};

export const browserUtils = {
  minWidths,
  removeElementById(id: string) {
    const elem = document.getElementById(id);
    if (elem) {
      elem.parentNode?.removeChild(elem);
    }
  },
  screen: {
    width,
    size,
    type,
  },
  isLocalhost(host: string) {
    return host.includes('localhost') || host.includes('127.0.0.1');
  },
};
